module.exports = __webpack_public_path__ + "img/fiveVideo.5226c508.jpg";